import React from 'react';

import Button, { BUTTON_TYPES } from 'buyside/components/presentation/Button/button';
import { PaginationButton } from 'buyside/components/presentation/Index/paginatedIndex';

import styles from './paginationButtonStyles.scss';

const MessageIndexPaginationButton = () => (
  <PaginationButton>
    {({ fetchNextPage }) => (
      <div className={styles.paginationButton}>
        <Button onClick={fetchNextPage} text="Load Older Messages" type={BUTTON_TYPES.LINK} />
      </div>
    )}
  </PaginationButton>
);

export default MessageIndexPaginationButton;
